/**
 * A special plus/check button that handles nuche subscription.
 */

import { useDispatch, useSelector } from "react-redux";

import { setServerResponse, showAuthModal } from "store/application/application-action";
import { apiNiches } from "services";
import { PinkBaseButton, SECONDARY, PRIMARY } from "components/buttons/PinkBaseButton";
import { IAppState } from "store/app-state";

export const NicheFollowButton = (props: {
  niche: string;
  following: boolean;
  onChange: (id: string, following: boolean) => void;
}): JSX.Element => {
  const currentUser = useSelector((state: IAppState) => state.user.currentUser);
  const isUserLoggedIn = !!Object.entries(currentUser).length;
  const dispatch = useDispatch();

  const onClick = async () => {
    if (!isUserLoggedIn) {
      dispatch(showAuthModal());
      return;
    }

    try {
      if (props.following) {
        await apiNiches.unfollow(props.niche);
        dispatch(setServerResponse("Not following this niche anymore."));
      } else {
        await apiNiches.follow(props.niche);
        dispatch(setServerResponse("Started following this niche."));
      }

      props.onChange(props.niche, !props.following);
    } catch (e) {
      console.error("Could not change niche status.");
    }
  };

  return (
    <PinkBaseButton
      variant={props.following ? SECONDARY : PRIMARY}
      onClick={onClick}
    >
      { props.following ? "Unfollow" : "Follow" }
    </PinkBaseButton>
  );
};
